module.exports = __webpack_public_path__ + "img/fr.e23d5bd6.svg";